<template>
  <div class="top-scroll block">
    <el-slider
      @input="input()"
      :max="maxValue"
      v-model="value"
      :show-tooltip="false"
    ></el-slider>
  </div>
</template>

<script>
export default {
  props: {
    refTarget: {
      type: String,
      default: "table",
    },
  },
  data() {
    return {
      value: 0,
      maxValue: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.initScroll);
  },
  mounted() {
    this.$nextTick(() => {
      this.initScroll();
    });
  },
  beforeDestroy() {
    if (this.$parent.$refs[this.refTarget]) {
      window.removeEventListener("resize", this.initScroll);
      this.$parent.$refs[this.refTarget].bodyWrapper.removeEventListener(
        "scroll",
        this.onScroll
      );
    }
  },
  methods: {
    initScroll() {
      if (this.$parent.$refs[this.refTarget]) {
        this.maxValue =
          this.$parent.$refs[this.refTarget].bodyWrapper.scrollWidth -
          this.$parent.$refs[this.refTarget].bodyWrapper.offsetWidth;

        this.$parent.$refs[this.refTarget].bodyWrapper.addEventListener(
          "scroll",
          this.onScroll
        );
      }
    },
    // 滑动时控制父层 scroll
    input() {
      if (this.$parent.$refs[this.refTarget]) {
        this.$parent.$refs[this.refTarget].bodyWrapper.scrollLeft = this.value;
      }
    },
    // 父层 onScroll
    onScroll() {
      if (this.$parent.$refs[this.refTarget]) {
        this.value = this.$parent.$refs[this.refTarget].bodyWrapper.scrollLeft;
      }
    },
  },
};
</script>

<style scoped>
.top-scroll /deep/ .el-slider {
  background-color: #e4e7ed;
  margin: 6px auto;
  overflow: hidden;
}
.top-scroll /deep/ .el-slider__button-wrapper {
  width: 100%;
  height: 8px;
  top: -7px;
}
.top-scroll /deep/ .el-slider__runway {
  width: calc(100% - 100px);
  margin: 0 auto;
  height: 8px;
}
.top-scroll /deep/ .el-slider__button {
  width: 100px;
  height: 10px;
  border: 0;
  background-color: #fcaa25;
  border-radius: 20px;
}
/* 防止 hover 按钮放大 */
.top-scroll /deep/ .el-slider__button-wrapper:hover .el-slider__button {
  transform: scale(1) !important;
}
.top-scroll /deep/ .el-slider__bar {
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/views/components/CusScroll.vue